import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const Arrays1D2D = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Arrays: 1D and 2D array"
    videos={[
      "https://www.youtube.com/embed/lAEmhJA-tVw"
    ]}
    takeaways={[
      { text: "From every topic in this module, learn all the pseudocodes." },
      { text: "Mainly focus on the time complexity of different topics." }
    ]}
    questions={[]}
    exampleVideos={[]}
  />
);
}

export default Arrays1D2D;
